<div class="col-sm-12 offset-md-1 col-md-10  mt-3">
    <div class="form-logo">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');">
            <img [src]="this.logo_url" alt="egd-logo">
        </a>
    </div>
    <div class="form-back  h4 my-4">
        <a [routerLink]="['/', this.slug]">&#8592; Back</a>
    </div>
    <div class="form-heading-section mt-4">
        <h2>Reset Password</h2>
        <!-- <p class="form-sub-heading">
            Just a step away from starting your consultation!
        </p> -->
        <!-- <p class="form-tagline"><small>Sign in with Email</small></p> -->
    </div>

    <div class="form-div">
        <p *ngIf="resetPasswordDone==true">Password Successfully updated. <br>Redirecting you to the home
            page....</p>
        <form #passwordResetForm="ngForm" (ngSubmit)="passwordResetSubmit()" *ngIf="resetPasswordDone==false"
            accept-charset="UTF-8">

            <div class="form-group row">
                <label class="col-sm-12 ml-1" for="password">Password*</label>
                <div class="input-div col-sm-12">
                    <div class="input-group">
                        <input id="password" name="password" [type]="isPassword?'password':'text'"
                            class="form-control input-of-input-icon" aria-describedby="password" placeholder="********"
                            [(ngModel)]="this.user_data.e_password" #password="ngModel" minlength="8"
                            FieldValidator="password"
                            [class.form-input-error]="(password.invalid && (password.dirty || password.touched)) && (password.errors.required)"
                            [class.form-input-success]="(!password.invalid && (password.dirty || password.touched)) && !(password.errors?.required || password.errors?.minlength)"
                            required>
                        <div class="input-group-append">
                            <span class="input-group-text icon-of-input-icon">
                                <i toggle="#password-field" role="button" class="fa fa-fw fa-question-circle text-dark"
                                    (click)="showTips()"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div *ngIf="(password.invalid && (password.dirty || password.touched))" class="col-sm-12">
                    <div *ngIf="password.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                        Password is required.
                    </div>
                    <div *ngIf="password.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2" role="alert">
                        Password should contain minimum 8 characters, at least 1 Uppercase, 1
                        Special Character and 1 number.
                    </div>
                    <div *ngIf="password.errors.minlength" class="col-sm-12 alert alert-danger m-2" role="alert">
                        Minimum length should be of 8 characters.
                    </div>
                </div>
                <div class="col-sm-12">
                    <div *ngIf="this.tipsPasswordShowed" class="col-sm-12 alert alert-danger m-2" role="alert">
                        Password should contain minimum 8 characters, at least 1 Uppercase, 1
                        Special Character and 1 number.
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-12 ml-1" for="password">Confirm Password*</label>
                <div class="input-div col-sm-12 pr-0">

                    <div class="input-group">
                        <input id="confirmPassword" name="confirmPassword" [type]="isPassword?'password':'text'"
                            class="form-control input-of-input-icon" aria-describedby="confirmPassword"
                            placeholder="********" [(ngModel)]="this.user_data.confirmpassword"
                            #confirmPassword="ngModel" minlength="8" FieldValidator="password"
                            [class.form-input-error]="(confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) && (confirmPassword.errors.required)"
                            [class.form-input-success]="(!confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) && !(confirmPassword.errors?.required || confirmPassword.errors?.minlength)"
                            required>

                        <div class="input-group-append">
                            <span class="input-group-text icon-of-input-icon">
                                <i toggle="#password-field" role="button" class="text-dark fa fa-fw"
                                    [ngClass]="{'fa-eye': isPassword,'fa-eye-slash': !isPassword}"
                                    (click)="changeType()"></i>
                            </span>
                        </div>
                    </div>

                </div>

                <div *ngIf="(confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched))"
                    class="col-sm-12">
                    <div *ngIf="confirmPassword.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                        Confirm Password is required.
                    </div>
                    <div *ngIf="confirmPassword.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                        role="alert">
                        Password should contain minimum 8 characters, at least 1 Uppercase, 1
                        Special Character and 1 number.
                    </div>
                    <div *ngIf="confirmPassword.errors.minlength" class="col-sm-12 alert alert-danger m-2" role="alert">
                        Minimum length should be of 8 characters.
                    </div>
                </div>
                <div class="col-sm-12">
                    <div *ngIf="confirmPassword.value!=password.value" class="col-sm-12 alert alert-danger m-2"
                        role="alert">
                        Password and Confirm Password do not match.
                    </div>
                </div>

            </div>

            <div class="form-group row justify-content-center">
                <div class="m-3">
                    <div id="recaptcha-div2">
                        <re-captcha *ngIf="this.recaptcha_Reset" class="recaptcha ng-valid" name="recaptcha" matInput
                            style="display: inline-block;" (resolved)="resolved($event)"
                            [(ngModel)]="this.user_data.recaptcha" #recaptcha="ngModel" [siteKey]="sitekey" required>
                        </re-captcha>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-12">
                    <div class="form-submit-button  my-3">
                        <button type="submit"
                            [disabled]="!passwordResetForm.valid || (user_data.e_password!=user_data.confirmpassword)"
                            class="btn btn-primary font-weight-bold text-white p-2">Reset Password</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="mt-3 mx-2">
            <div class="text-center">
                <div class="spinner-border text-primary" role="status" *ngIf="formPosting==true">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>

            <div
                *ngIf="(this.response?.success!=null && this.response?.success==false) && (this.response?.error!=null)">
                <div class="alert alert-danger">{{this.response?.error.message}}</div>
            </div>
            <div
                *ngIf="(this.response?.success!=null && this.response?.success==false) && (this.serverError?.error!=null && this.serverError?.statusCode!=500)">
                <div class="alert alert-danger" *ngFor="let message of this.serverError?.message">{{message}}
                </div>
            </div>
            <div
                *ngIf="(this.response?.success!=null && this.response?.success==false) && (this.serverError?.error!=null && this.serverError?.statusCode==500)">
                <div class="alert alert-danger">{{this.serverError?.message}}</div>
            </div>

            <div class="alert alert-danger" *ngIf='result?.error!=null && !result?.error.message'>
                {{result.error}}
            </div>
        </div>
    </div>

    <div class="footer-copyright-section mt-4">
        <p class="footer-copyright-text text-center">
            2025 Copyright <span>&#169;</span> All rights reserved by <a href="javascript:void(0)"
                (click)="openLink('HOMPAGE_BASE_URL','','_self');" style="color: #1850A0;">eGlobalDoctors</a>
        </p>
    </div>

</div>